import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';
import { TableCell, TableRow, Stack } from '@mui/material';
import AvatarTextField from 'src/components/widgets/avatar-textfield';
import PaginatedTable from 'src/components/ui/table/paginated-table';
import HeaderTableCell from 'src/components/ui/table/header-table-cell';

export const ListTable = (props) => {
  const {
    dataStore,
    onPageChange = () => {},
    onRowsPerPageChange,
    page = 0,
    rowsPerPage = 0,
    selected = [],
    onDetailClicked,
  } = props;

  const { t } = useTranslation();

  return (
    <PaginatedTable
      items={dataStore.items}
      loading={dataStore.loading}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      renderItem={(item, rowstyle) => (
        <TableRow hover selected={selected.includes(item.id)} sx={rowstyle}>
          <TableCell>
            <AvatarTextField avatarSrc={item.avatar} avatarName={item.gender} value={item.name} 
              onClick={() => onDetailClicked(item)} avatarSx={{ color: item.statusColor }} />
        </TableCell>
          <TableCell>{item.code}</TableCell>
          <TableCell>{item.phone}</TableCell>
          <TableCell>{item.birthday}</TableCell>
          <TableCell sx={{ textAlign: 'right', whiteSpace: 'nowrap' }}>{item.options}</TableCell>
        </TableRow>
      )}
    >
      <TableRow>
        <HeaderTableCell sx={{ width: '28%' }}>{t(appStr.txt_002)}</HeaderTableCell>
        <HeaderTableCell sx={{ width: '12%' }}>{t(appStr.txt_059)}</HeaderTableCell>
        <HeaderTableCell sx={{ width: '15%' }}>{t(appStr.txt_020)}</HeaderTableCell>
        <HeaderTableCell sx={{ width: '15%' }}>{t(appStr.txt_022)}</HeaderTableCell>
        <HeaderTableCell sx={{ textAlign: 'right', whiteSpace: 'nowrap' }} />
      </TableRow>
    </PaginatedTable>
  );
};

ListTable.propTypes = {
  dataStore: PropTypes.object,
  onDeselectAll: PropTypes.func,
  onDeselectOne: PropTypes.func,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  onSelectOne: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array,
};
